import { RegionData } from "../models/region.model";
import {
  TravelMixData,
} from "../models/TravelMixData.model";
import { LuggageAmountValues } from "../models/LuggageAmountValues.model";
import { LuggageAmounteServiceClass } from "../models/LuggageAmounteServiceClass.model";
import { Season } from "../models/Season.model";
import { TransportMode } from "../models/transportMode.model";
import {
  SecurityAdjustmentFactor,
  SecurityAdjustmentFactorValue,
} from "../models/SecurityAdjustmentFactor.model";
import { BoolEnum } from "../models/enums/BoolEnum";
import {
  LuggagePerFoldingSeat,
  LuggagePerFoldingSeatValue,
} from "../models/LuggagePerFoldingSeat.model";
import { getServiceClassOrder } from "./changeServiceClassesOrder";
import { DensityOfPeoplefactor } from "./ImportScheme/DensityOfPeopleFactor.scheme";

const BACKSLASH_N: string = "\n";

export class FileImport {
  regionDataOutput: RegionData;
  constructor(
    private regionData: RegionData,
    private seasons: Season[],
    private transportModes: TransportMode[],
    contentText: string
  ) {
    this.splitText(contentText);
    this.regionDataOutput = this.regionData;
  }

  splitText(text: string) {
    text = text.replace(/\r?\n|\r/g, BACKSLASH_N);

    var tabs = text.split("#");
    for (var index = 0; index < tabs.length; index++) {
      var parts = tabs[index].split(";");
      if (parts[0] === "Region") {
        this.splitRegionTab(tabs[index]);
      } else if (parts[0] === "AgeGenderDistribution") {
        this.splitTabAgeGenderDistribution(tabs[index]);
      } else if (parts[0] === "AgeGenderLuggageFaktor") {
        this.splitTabAgeGenderLuggageFaktor(tabs[index]);
      } else if (parts[0] === "LuggageSize") {
        this.splitTabLuggageSize(tabs[index]);
      } else if (parts[0] === "StorageAcceptance") {
        this.splitTabStorageAcceptance(tabs[index]);
      } else if (parts[0] === "StorageFactor") {
        this.splitTabStorageFactor(tabs[index]);
      } else if (parts[0] === "TravelMix") {
        this.splitTabTravelMix(tabs[index]);
      } else if (parts[0] === "AgeGenderAdaptation") {
        this.splitTabAgeGenderAdaptation(tabs[index]);
      } else if (parts[0] === "PassengerChangeTimeVector") {
        this.splitTabPassengerChangeTimeVector(tabs[index]);
      } else if (parts[0] === "DoorWidthReduction") {
        this.splitTabDoorWidthReduction(tabs[index]);
      } else if (parts[0] === "DoorWidthAndPhysicalSeparationFactor") {
        this.splitTabDoorWidthAndPhysicalSeparationFactor(tabs[index]);
      } else if (parts[0] === "FactorSet") {
        this.splitFactorSet(tabs[index]);
      } else if (parts[0] === "AisleWidth") {
        this.splitTabAisleWidth(tabs[index]);
      } else if (parts[0] === "AlternativeRooms") {
        this.splitTabAlternativeRooms(tabs[index]);
      } else if (parts[0] === "AccessibilityOfTheSeatsFactor") {
        this.splitTabAccessibilityOfTheSeatsFactor(tabs[index]);
      } else if (parts[0] === "AmountOfNotStorableBaggage") {
        this.splitTabAmountOfNotStorableBaggage(tabs[index]);
      } else if (parts[0] === "SimplicityLuggageAccommodation") {
        this.splitTabSimplicityLuggageAccommodation(tabs[index]);
      } else if (parts[0] === "LuggageRacksWhenBoarding") {
        this.splitTabLuggageRacksWhenBoarding(tabs[index]);
      } else if (parts[0] === "BaggageAccumulation") {
        this.splitTabBaggageAccumulation(tabs[index]);
      } else if (parts[0] === "ReservationObligation") {
        this.splitTabReservationObligation(tabs[index]);
      } else if (parts[0] === "CompartmentsAvailable") {
        this.splitTabCompartmentsAvailable(tabs[index]);
      } else if (parts[0] === "SeatsPerRunningMeter") {
        this.splitTabSeatsPerRunningMeter(tabs[index]);
      } else if (parts[0] === "AgeDistribution") {
        this.splitTabAgeDistribution(tabs[index]);
      } else if (parts[0] === "AgeGenderAdaptationSteps") {
        this.splitTabAgeGenderAdaptationSteps(tabs[index]);
      } else if (parts[0] === "PassengerChangeTimeVectorSteps") {
        this.splitTabPassengerChangeTimeVectorSteps(tabs[index]);
      } else if (parts[0] === "StepsWidthFactor") {
        this.splitTabStepsWidthFactor(tabs[index]);
      } else if (parts[0] === "BoardingPlaceDensityOfPeopleFactor") {
        this.splitTabBoardingPlaceDensityOfPeopleFactor(tabs[index]);
      } else if (parts[0] === "LocationWaysFactor") {
        this.splitTabLocationWaysFactor(tabs[index]);
      } else if (parts[0] === "SpecialFactors") {
        this.splitTabSpecialFactors(tabs[index]);
      }
    }
  }

  splitRegionTab(text: string) {
    var lines = text.split(BACKSLASH_N);

    var name: string = lines[1].split(";")[1];

    var seatOccupancyRateDefault_UrbanPublicTransport: number = parseFloat(
      lines[4].split(";")[1].replace(",", ".")
    );
    var standingOccupancyRateDefault_UrbanPublicTransport: number = parseFloat(
      lines[5].split(";")[1].replace(",", ".")
    );
    var personsPerSquareMeterMultiPurposeArea_UrbanPublicTransport: number =
      parseFloat(lines[6].split(";")[1].replace(",", "."));
    var personsPerSquareMeterEntranceArea_UrbanPublicTransport: number =
      parseFloat(lines[7].split(";")[1].replace(",", "."));
    var personsPerSquareMeterAisle_UrbanPublicTransport: number = parseFloat(
      lines[8].split(";")[1].replace(",", ".")
    );
    var personsBoardingDefault_UrbanPublicTransport: number = parseFloat(
      lines[9].split(";")[1].replace(",", ".")
    );
    var personsDeboardingDefault_UrbanPublicTransport: number = parseFloat(
      lines[10].split(";")[1].replace(",", ".")
    );
    var valueFormat_UrbanPublicTransport = lines[11].split(";")[1];

    var seatOccupancyRateDefault_RegionalPublicTransport: number = parseFloat(
      lines[13].split(";")[1].replace(",", ".")
    );
    var standingOccupancyRateDefault_RegionalPublicTransport: number =
      parseFloat(lines[14].split(";")[1].replace(",", "."));
    var personsPerSquareMeterMultiPurposeArea_RegionalPublicTransport: number =
      parseFloat(lines[15].split(";")[1].replace(",", "."));
    var personsPerSquareMeterEntranceArea_RegionalPublicTransport: number =
      parseFloat(lines[16].split(";")[1].replace(",", "."));
    var personsPerSquareMeterAisle_RegionalPublicTransport: number = parseFloat(
      lines[17].split(";")[1].replace(",", ".")
    );
    var personsBoardingDefault_RegionalPublicTransport: number = parseFloat(
      lines[18].split(";")[1].replace(",", ".")
    );
    var personsDeboardingDefault_RegionalPublicTransport: number = parseFloat(
      lines[19].split(";")[1].replace(",", ".")
    );
    var valueFormat_RegionalPublicTransport = lines[20].split(";")[1];

    var seatOccupancyRateDefault_LongDistanceTransport: number = parseFloat(
      lines[22].split(";")[1].replace(",", ".")
    );
    var standingOccupancyRateDefault_LongDistanceTransport: number = parseFloat(
      lines[23].split(";")[1].replace(",", ".")
    );
    var personsPerSquareMeterMultiPurposeArea_LongDistanceTransport: number =
      parseFloat(lines[24].split(";")[1].replace(",", "."));
    var personsPerSquareMeterEntranceArea_LongDistanceTransport: number =
      parseFloat(lines[25].split(";")[1].replace(",", "."));
    var personsPerSquareMeterAisle_LongDistanceTransport: number = parseFloat(
      lines[26].split(";")[1].replace(",", ".")
    );
    var personsBoardingDefault_LongDistanceTransport: number = parseFloat(
      lines[27].split(";")[1].replace(",", ".")
    );
    var personsDeboardingDefault_LongDistanceTransport: number = parseFloat(
      lines[28].split(";")[1].replace(",", ".")
    );
    var valueFormat_LongDistanceTransport = lines[29].split(";")[1];

    this.regionData.name = name;

    for (var index = 0; index < this.regionData.defaults.length; index++) {
      if (
        this.regionData.defaults[index].transportModeName ===
        "Urban public transport"
      ) {
        this.regionData.defaults[index].default.seatOccupancyRateDefault =
          seatOccupancyRateDefault_UrbanPublicTransport;
        this.regionData.defaults[index].default.standingOccupancyRateDefault =
          standingOccupancyRateDefault_UrbanPublicTransport;
        this.regionData.defaults[index].default.personsBoardingDefault =
          personsBoardingDefault_UrbanPublicTransport;
        this.regionData.defaults[index].default.personsDeboardingDefault =
          personsDeboardingDefault_UrbanPublicTransport;
        this.regionData.defaults[
          index
        ].default.personsPerSquareMeterMultiPurposeArea = personsPerSquareMeterMultiPurposeArea_UrbanPublicTransport;
        this.regionData.defaults[
          index
        ].default.personsPerSquareMeterEntranceArea = personsPerSquareMeterEntranceArea_UrbanPublicTransport;
        this.regionData.defaults[index].default.personsPerSquareMeterAisle =
          personsPerSquareMeterAisle_UrbanPublicTransport;

        //ToDo use name of Value Format Lookup
        if (valueFormat_UrbanPublicTransport[0] === "P") {
          this.regionData.defaults[index].default.personValueFormatId = 1;
        } else if (valueFormat_UrbanPublicTransport[0] === "A") {
          this.regionData.defaults[index].default.personValueFormatId = 2;
        }
      } else if (
        this.regionData.defaults[index].transportModeName ===
        "Regional public transport"
      ) {
        this.regionData.defaults[index].default.seatOccupancyRateDefault =
          seatOccupancyRateDefault_RegionalPublicTransport;
        this.regionData.defaults[index].default.standingOccupancyRateDefault =
          standingOccupancyRateDefault_RegionalPublicTransport;
        this.regionData.defaults[index].default.personsBoardingDefault =
          personsBoardingDefault_RegionalPublicTransport;
        this.regionData.defaults[index].default.personsDeboardingDefault =
          personsDeboardingDefault_RegionalPublicTransport;
        this.regionData.defaults[
          index
        ].default.personsPerSquareMeterMultiPurposeArea = personsPerSquareMeterMultiPurposeArea_RegionalPublicTransport;
        this.regionData.defaults[
          index
        ].default.personsPerSquareMeterEntranceArea = personsPerSquareMeterEntranceArea_RegionalPublicTransport;
        this.regionData.defaults[index].default.personsPerSquareMeterAisle =
          personsPerSquareMeterAisle_RegionalPublicTransport;

        //ToDo use name of Value Format Lookup
        if (valueFormat_RegionalPublicTransport[0] === "P") {
          this.regionData.defaults[index].default.personValueFormatId = 1;
        } else if (valueFormat_UrbanPublicTransport[0] === "A") {
          this.regionData.defaults[index].default.personValueFormatId = 2;
        }
      } else if (
        this.regionData.defaults[index].transportModeName ===
        "Long-distance transport"
      ) {
        this.regionData.defaults[index].default.seatOccupancyRateDefault =
          seatOccupancyRateDefault_LongDistanceTransport;
        this.regionData.defaults[index].default.standingOccupancyRateDefault =
          standingOccupancyRateDefault_LongDistanceTransport;
        this.regionData.defaults[index].default.personsBoardingDefault =
          personsBoardingDefault_LongDistanceTransport;
        this.regionData.defaults[index].default.personsDeboardingDefault =
          personsDeboardingDefault_LongDistanceTransport;
        this.regionData.defaults[
          index
        ].default.personsPerSquareMeterMultiPurposeArea = personsPerSquareMeterMultiPurposeArea_LongDistanceTransport;
        this.regionData.defaults[
          index
        ].default.personsPerSquareMeterEntranceArea = personsPerSquareMeterEntranceArea_LongDistanceTransport;
        this.regionData.defaults[index].default.personsPerSquareMeterAisle =
          personsPerSquareMeterAisle_LongDistanceTransport;

        //ToDo use name of Value Format Lookup
        if (valueFormat_LongDistanceTransport[0] === "P") {
          this.regionData.defaults[index].default.personValueFormatId = 1;
        } else if (valueFormat_UrbanPublicTransport[0] === "A") {
          this.regionData.defaults[index].default.personValueFormatId = 2;
        }
      }
    }
  }
  splitTabAgeGenderDistribution(text: string) {
    var ageGenders: number = 12;
    var lines = text.split(BACKSLASH_N);
    var values = lines[2].split(";");
    for (var index = 0; index < ageGenders; index++) {
      values[index] = values[index].replace(",", ".").replace("%", "");
      var ageGenderId = index;
      var value = parseFloat(values[index]);
      for (
        var index2 = 0;
        index2 < this.regionData.ageGenderDistribution.values.length;
        index2++
      ) {
        if (
          this.regionData.ageGenderDistribution.values[index2].ageGenderId ===
          ageGenderId
        ) {
          this.regionData.ageGenderDistribution.values[index2].value = value;
          break;
        }
      }
    }
  }

  splitTabSpecialFactors(text: string) {
    var lines = text.split(BACKSLASH_N);

    this.regionData.notUsableSeatFactorValue = parseFloat(
      lines[1].split(";")[1].replace(",", ".")
    );
    this.regionData.oppositeDoorReductionFactorValue = parseFloat(
      lines[2].split(";")[1].replace(",", ".")
    );
    this.regionData.beforeSeatReductionFactorValue = parseFloat(
      lines[3].split(";")[1].replace(",", ".")
    );
    this.regionData.distanceBetweenPeople = parseFloat(
      lines[4].split(";")[1].replace(",", ".")
    );
    this.regionData.distanceBetweenPeopleAisle = parseFloat(
      lines[5].split(";")[1].replace(",", ".")
    );
    this.regionData.distanceBetweenPeopleStairs = parseFloat(
      lines[6].split(";")[1].replace(",", ".")
    );
    this.regionData.rackCapacityRoundingThreshold = parseFloat(
      lines[7].split(";")[1].replace(",", ".")
    );
    this.regionData.minimumUnderSeatHeight = parseFloat(
      lines[8].split(";")[1].replace(",", ".")
    );
    this.regionData.overheadHeightReductionFactor = parseFloat(
      lines[9].split(";")[1].replace(",", ".")
    );
    this.regionData.overheadLengthReductionFactor = parseFloat(
      lines[10].split(";")[1].replace(",", ".")
    );
    this.regionData.overheadLengthReductionThreshold = parseFloat(
      lines[11].split(";")[1].replace(",", ".")
    );
    this.regionData.handleReductionFactor = parseFloat(
      lines[12].split(";")[1].replace(",", ".")
    );

    let securityAdjustmentFactor: SecurityAdjustmentFactor =
      new SecurityAdjustmentFactor();
    securityAdjustmentFactor.id = this.regionData.securityAdjustmentFactor.id;

    let securityAdjustmentFactorValues: SecurityAdjustmentFactorValue[] = [];

    let securityAdjustmentFactorValue1: SecurityAdjustmentFactorValue =
      new SecurityAdjustmentFactorValue();
    securityAdjustmentFactorValue1.securitytId = 0;
    securityAdjustmentFactorValue1.value = parseFloat(
      lines[14].split(";")[1].replace(",", ".")
    );

    let securityAdjustmentFactorValue2: SecurityAdjustmentFactorValue =
      new SecurityAdjustmentFactorValue();
    securityAdjustmentFactorValue2.securitytId = 1;
    securityAdjustmentFactorValue2.value = parseFloat(
      lines[15].split(";")[1].replace(",", ".")
    );

    let securityAdjustmentFactorValue3: SecurityAdjustmentFactorValue =
      new SecurityAdjustmentFactorValue();
    securityAdjustmentFactorValue3.securitytId = 2;
    securityAdjustmentFactorValue3.value = parseFloat(
      lines[16].split(";")[1].replace(",", ".")
    );

    securityAdjustmentFactorValues.push(securityAdjustmentFactorValue1);
    securityAdjustmentFactorValues.push(securityAdjustmentFactorValue2);
    securityAdjustmentFactorValues.push(securityAdjustmentFactorValue3);

    securityAdjustmentFactor.values = securityAdjustmentFactorValues;

    this.regionData.securityAdjustmentFactor = securityAdjustmentFactor;

    let luggagePerFoldingSeat: LuggagePerFoldingSeat =
      new LuggagePerFoldingSeat();
    luggagePerFoldingSeat.id = this.regionData.luggagePerFoldingSeat.id;

    let luggagePerFoldingSeatValues: LuggagePerFoldingSeatValue[] = [];

    let luggagePerFoldingSeatValue1: LuggagePerFoldingSeatValue =
      new LuggagePerFoldingSeatValue();
    luggagePerFoldingSeatValue1.transportModeId = 1;
    luggagePerFoldingSeatValue1.value = parseFloat(
      lines[18].split(";")[1].replace(",", ".")
    );

    let luggagePerFoldingSeatValue2: LuggagePerFoldingSeatValue =
      new LuggagePerFoldingSeatValue();
    luggagePerFoldingSeatValue2.transportModeId = 2;
    luggagePerFoldingSeatValue2.value = parseFloat(
      lines[19].split(";")[1].replace(",", ".")
    );

    let luggagePerFoldingSeatValue3: LuggagePerFoldingSeatValue =
      new LuggagePerFoldingSeatValue();
    luggagePerFoldingSeatValue3.transportModeId = 3;
    luggagePerFoldingSeatValue3.value = parseFloat(
      lines[20].split(";")[1].replace(",", ".")
    );

    luggagePerFoldingSeatValues.push(luggagePerFoldingSeatValue1);
    luggagePerFoldingSeatValues.push(luggagePerFoldingSeatValue2);
    luggagePerFoldingSeatValues.push(luggagePerFoldingSeatValue3);

    luggagePerFoldingSeat.values = luggagePerFoldingSeatValues;

    this.regionData.luggagePerFoldingSeat = luggagePerFoldingSeat;
  }

  splitTabAgeGenderLuggageFaktor(text: string) {
    var ageGenders: number = 12;
    var luggageTypes: number = 14;
    var lines = text.split(BACKSLASH_N);
    for (var index = 2; index < ageGenders + 2; index++) {
      var values = lines[index].split(";");
      for (var index2 = 1; index2 < luggageTypes + 1; index2++) {
        var ageGenderId = index - 2;
        var luggageTypeId = index2 - 1;
        var value = parseFloat(values[index2].replace(",", "."));

        for (
          var index3 = 0;
          index3 < this.regionData.ageGenderLuggageFaktor.values.length;
          index3++
        ) {
          if (
            this.regionData.ageGenderLuggageFaktor.values[index3].ageGenderId ==
              ageGenderId &&
            this.regionData.ageGenderLuggageFaktor.values[index3]
              .luggageTypeId == luggageTypeId
          ) {
            this.regionData.ageGenderLuggageFaktor.values[index3].value = value;
            break;
          }
        }
      }
    }
  }

  splitTabLuggageSize(text: string) {
    var luggageTypes: number = 14;
    var lines = text.split(BACKSLASH_N);
    for (var index = 2; index < 5; index++) {
      var values = lines[index].split(";");
      for (var index2 = 1; index2 < luggageTypes + 1; index2++) {
        var luggageTypeId = index2 - 1;
        var value = parseFloat(values[index2].replace(",", "."));
        for (
          var index3 = 0;
          index3 < this.regionData.luggageSize.luggageSizeList.length;
          index3++
        ) {
          if (
            luggageTypeId ==
            this.regionData.luggageSize.luggageSizeList[index3].luggageTypeId
          ) {
            if (index === 2) {
              this.regionData.luggageSize.luggageSizeList[index3].x = value;
            } else if (index === 3) {
              this.regionData.luggageSize.luggageSizeList[index3].y = value;
            } else if (index === 4) {
              this.regionData.luggageSize.luggageSizeList[index3].z = value;
            }
          }
        }
      }
    }
  }
  splitTabStorageAcceptance(text: string) {
    var luggageTypes: number = 14;
    var storageTypes: number = 10;
    var lines = text.split(BACKSLASH_N);

    //Standard
    var countStorageTypeId = 0;
    var countLuggageTypeId = 0;
    var beginStandard: number = 2;
    var endStandard: number = storageTypes + 2;

    for (var index = beginStandard; index < endStandard; index++) {
      var values = lines[index].split(";");
      countLuggageTypeId = 0;
      for (var index2 = 1; index2 < luggageTypes + 1; index2++) {
        var storageTypeId = countStorageTypeId;
        var luggageTypeId = countLuggageTypeId;
        var value = parseFloat(values[index2].replace(",", "."));

        for (
          var index3 = 0;
          index3 <
          this.regionData.storageAcceptance.storageAcceptancePerComfortTypeList
            .length;
          index3++
        ) {
          if (
            this.regionData.storageAcceptance
              .storageAcceptancePerComfortTypeList[index3].comfortTypeId == 1
          ) {
            for (
              var index4 = 0;
              index4 <
              this.regionData.storageAcceptance
                .storageAcceptancePerComfortTypeList[index3]
                .storageAcceptanceValueList.length;
              index4++
            ) {
              if (
                this.regionData.storageAcceptance
                  .storageAcceptancePerComfortTypeList[index3]
                  .storageAcceptanceValueList[index4].luggageTypeId ==
                  luggageTypeId &&
                this.regionData.storageAcceptance
                  .storageAcceptancePerComfortTypeList[index3]
                  .storageAcceptanceValueList[index4].storageSpaceId ==
                  storageTypeId
              ) {
                this.regionData.storageAcceptance.storageAcceptancePerComfortTypeList[
                  index3
                ].storageAcceptanceValueList[index4].value = value;
              }
            }
          }
        }
        countLuggageTypeId++;
      }
      countStorageTypeId++;
    }

    //Comfort
    var beginComfort: number = 4 + storageTypes;
    var endComfort: number = 4 + storageTypes * 2;
    countStorageTypeId = 0;
    for (var index = beginComfort; index < endComfort; index++) {
      var values = lines[index].split(";");
      countLuggageTypeId = 0;
      for (var index2 = 1; index2 < luggageTypes + 1; index2++) {
        var storageTypeId = countStorageTypeId;
        var luggageTypeId = countLuggageTypeId;
        var value = parseFloat(values[index2].replace(",", "."));

        for (
          var index3 = 0;
          index3 <
          this.regionData.storageAcceptance.storageAcceptancePerComfortTypeList
            .length;
          index3++
        ) {
          if (
            this.regionData.storageAcceptance
              .storageAcceptancePerComfortTypeList[index3].comfortTypeId == 2
          ) {
            for (
              var index4 = 0;
              index4 <
              this.regionData.storageAcceptance
                .storageAcceptancePerComfortTypeList[index3]
                .storageAcceptanceValueList.length;
              index4++
            ) {
              if (
                this.regionData.storageAcceptance
                  .storageAcceptancePerComfortTypeList[index3]
                  .storageAcceptanceValueList[index4].luggageTypeId ==
                  luggageTypeId &&
                this.regionData.storageAcceptance
                  .storageAcceptancePerComfortTypeList[index3]
                  .storageAcceptanceValueList[index4].storageSpaceId ==
                  storageTypeId
              ) {
                this.regionData.storageAcceptance.storageAcceptancePerComfortTypeList[
                  index3
                ].storageAcceptanceValueList[index4].value = value;
              }
            }
          }
        }
        countLuggageTypeId++;
      }
      countStorageTypeId++;
    }

    //Treshold
    var beginTreshold: number = 6 + storageTypes * 2;
    var endTreshold: number = 6 + storageTypes * 3;
    countStorageTypeId = 0;
    for (var index = beginTreshold; index < endTreshold; index++) {
      var values = lines[index].split(";");
      countLuggageTypeId = 0;
      for (var index2 = 1; index2 < luggageTypes + 1; index2++) {
        var storageTypeId = countStorageTypeId;
        var luggageTypeId = countLuggageTypeId;
        var value = parseFloat(values[index2].replace(",", "."));

        for (
          var index3 = 0;
          index3 <
          this.regionData.storageAcceptance.storageAcceptancePerComfortTypeList
            .length;
          index3++
        ) {
          if (
            this.regionData.storageAcceptance
              .storageAcceptancePerComfortTypeList[index3].comfortTypeId == 3
          ) {
            for (
              var index4 = 0;
              index4 <
              this.regionData.storageAcceptance
                .storageAcceptancePerComfortTypeList[index3]
                .storageAcceptanceValueList.length;
              index4++
            ) {
              if (
                this.regionData.storageAcceptance
                  .storageAcceptancePerComfortTypeList[index3]
                  .storageAcceptanceValueList[index4].luggageTypeId ==
                  luggageTypeId &&
                this.regionData.storageAcceptance
                  .storageAcceptancePerComfortTypeList[index3]
                  .storageAcceptanceValueList[index4].storageSpaceId ==
                  storageTypeId
              ) {
                this.regionData.storageAcceptance.storageAcceptancePerComfortTypeList[
                  index3
                ].storageAcceptanceValueList[index4].value = value;
              }
            }
          }
        }
        countLuggageTypeId++;
      }
      countStorageTypeId++;
    }
  }

  splitTabStorageFactor(text: string) {
    var ageGenders: number = 12;
    var storageTypes: number = 10;
    var lines = text.split(BACKSLASH_N);

    for (var index = 2; index < storageTypes + 2; index++) {
      var values = lines[index].split(";");
      for (var index2 = 1; index2 < ageGenders + 1; index2++) {
        var storageTypeId = index - 2;
        var ageGenderId = index2 - 1;
        var value = parseFloat(values[index2].replace(",", "."));

        for (
          var index3 = 0;
          index3 < this.regionData.ageGenderStorageFactor.values.length;
          index3++
        ) {
          if (
            this.regionData.ageGenderStorageFactor.values[index3].ageGenderId ==
              ageGenderId &&
            this.regionData.ageGenderStorageFactor.values[index3]
              .storageSpaceId == storageTypeId
          ) {
            this.regionData.ageGenderStorageFactor.values[index3].value = value;
          }
        }
      }
    }
  }
  splitTabTravelMix(text: string) {
    let travelMix: TravelMixData = new TravelMixData();

    var lines = text.split(BACKSLASH_N);
    var name: string = lines[1].split(";")[1];
    var airportConnectionText = lines[2].split(";")[1];
    var airportConnection: boolean;
    var falseString: string = BoolEnum[BoolEnum.False];
    var trueString: string = BoolEnum[BoolEnum.True];

    if (airportConnectionText === trueString) {
      airportConnection = true;
    } else if (airportConnectionText === falseString) {
      airportConnection = false;
    }
    var harbourConnectionText = lines[3].split(";")[1];
    var harbourConnection: boolean;
    if (harbourConnectionText === trueString) {
      harbourConnection = true;
    } else if (harbourConnectionText === falseString) {
      harbourConnection = false;
    }

    var seasons = lines[4]
      .split(";")
      .splice(1, lines[4].split(";").length - 1)
      .filter((f) => f != "" && f.match(".*[a-zA-Z]+.*"));
    var transports = lines[5]
      .split(";")
      .splice(1, lines[5].split(";").length - 1)
      .filter((f) => f != "" && f.match(".*[a-zA-Z]+.*"));
    let seasoIds: number[] = [];
    let transportModeIds: number[] = [];
    for (var index = 0; index < this.seasons.length; index++) {
      for (var index2 = 0; index2 < seasons.length; index2++) {
        if (seasons[index2] == this.seasons[index].name) {
          seasoIds.push(this.seasons[index].id);
          break;
        }
      }
    }
    for (var index = 0; index < this.transportModes.length; index++) {
      for (var index2 = 0; index2 < transports.length; index2++) {
        if (transports[index2] == this.transportModes[index].name) {
          transportModeIds.push(this.transportModes[index].id);
          break;
        }
      }
    }

    let luggageAmounts: LuggageAmounteServiceClass[] = [];
    var luggageTypes: number = 14;
    var classTypes: number = 7;

    var newServiceClassOrder: number[] = getServiceClassOrder();

    for (var index = 8; index < 8 + newServiceClassOrder.length; index++) {
      var values = lines[index].split(";");
      var classId = newServiceClassOrder[index - 8];
      let luggageAmount: LuggageAmounteServiceClass =
        new LuggageAmounteServiceClass();
      luggageAmount.serviceClassId = classId;
      let luggageAmountValues: LuggageAmountValues[] = [];

      for (var index2 = 1; index2 < luggageTypes + 1; index2++) {
        var luggageTypeId = index2 - 1;
        var value = parseFloat(values[index2].replace(",", "."));
        let luggageAmountValue: LuggageAmountValues = new LuggageAmountValues();
        luggageAmountValue.luggageTypeId = luggageTypeId;
        luggageAmountValue.value = value;
        luggageAmountValues.push(luggageAmountValue);
      }
      luggageAmount.luggageValues = luggageAmountValues;
      luggageAmounts.push(luggageAmount);
    }

    travelMix.id = -1;
    travelMix.name = name;
    travelMix.airportConnection = airportConnection;
    travelMix.harbourConnection = harbourConnection;
    travelMix.regionId = this.regionData.id;
    travelMix.seasonIds = seasoIds;
    travelMix.transportModeIds = transportModeIds;
    travelMix.luggageAmounteServiceClasses = luggageAmounts;
    this.regionData.travelMixes.push(travelMix);
  }

  splitTabAgeGenderAdaptation(text: string) {
    var ageGenders: number = 12;
    var luggageCategory: number = 5;
    var lines = text.split(BACKSLASH_N);
    for (var index = 2; index < ageGenders + 2; index++) {
      var values = lines[index].split(";");
      for (var index2 = 1; index2 < luggageCategory + 1; index2++) {
        var ageGenderId = index - 2;
        var luggageCategoryId = index2; //LuggageCategories Beginnen mit 1 und nicht mit 0
        var value = parseFloat(values[index2].replace(",", "."));

        for (
          var index3 = 0;
          index3 < this.regionData.ageGenderAdaptation.values.length;
          index3++
        ) {
          const element = this.regionData.ageGenderAdaptation.values[index3];

          if (
            element.ageGenderId == ageGenderId &&
            element.luggageCategoryId == luggageCategoryId &&
            element.timeTypeId == 1
          ) {
            this.regionData.ageGenderAdaptation.values[index3].value = value;
            break;
          }
        }
      }
    }
    for (
      var index = 2 + ageGenders + 2;
      index < 2 + ageGenders + 2 + ageGenders;
      index++
    ) {
      var values = lines[index].split(";");
      for (var index2 = 1; index2 < luggageCategory + 1; index2++) {
        var ageGenderId = index - 2 - ageGenders - 2;
        var luggageCategoryId = index2; //LuggageCategories Beginnen mit 1 und nicht mit 0
        var value = parseFloat(values[index2].replace(",", "."));

        for (
          var index3 = 0;
          index3 < this.regionData.ageGenderAdaptation.values.length;
          index3++
        ) {
          const element = this.regionData.ageGenderAdaptation.values[index3];

          if (
            element.ageGenderId == ageGenderId &&
            element.luggageCategoryId == luggageCategoryId &&
            element.timeTypeId == 2
          ) {
            this.regionData.ageGenderAdaptation.values[index3].value = value;
            break;
          }
        }
      }
    }
  }
  splitTabPassengerChangeTimeVector(text: string) {
    var steps: number = 6;
    var luggageCategory: number = 5;
    var lines = text.split(BACKSLASH_N);
    for (var index = 2; index < luggageCategory + 2; index++) {
      var values = lines[index].split(";");
      for (var index2 = 1; index2 < steps + 1; index2++) {
        var stepsId = index2;
        var luggageCategoryId = index - 1; //LuggageCategories Beginnen mit 1 und nicht mit 0
        var value = parseFloat(values[index2].replace(",", "."));
        for (
          var index3 = 0;
          index3 < this.regionData.passengerChangeTimeVector.values.length;
          index3++
        ) {
          const element =
            this.regionData.passengerChangeTimeVector.values[index3];

          if (
            element.stepsAmountId == stepsId &&
            element.luggageCategoryId == luggageCategoryId &&
            element.timeTypeId == 1
          ) {
            this.regionData.passengerChangeTimeVector.values[index3].value =
              value;
            break;
          }
        }
      }
    }
    for (
      var index = 2 + steps + 1;
      index < (luggageCategory + 2) * 2;
      index++
    ) {
      var values = lines[index].split(";");
      for (var index2 = 1; index2 < steps + 1; index2++) {
        var stepsId = index2;
        var luggageCategoryId = index - 1 - steps - 1; //LuggageCategories Beginnen mit 1 und nicht mit 0
        var value = parseFloat(values[index2].replace(",", "."));
        for (
          var index3 = 0;
          index3 < this.regionData.passengerChangeTimeVector.values.length;
          index3++
        ) {
          const element =
            this.regionData.passengerChangeTimeVector.values[index3];

          if (
            element.stepsAmountId == stepsId &&
            element.luggageCategoryId == luggageCategoryId &&
            element.timeTypeId == 2
          ) {
            this.regionData.passengerChangeTimeVector.values[index3].value =
              value;
            break;
          }
        }
      }
    }
  }
  splitTabDoorWidthReduction(text: string) {
    var doorWidthReals: number = 3;
    var standbacks: number = 5;
    var lines = text.split(BACKSLASH_N);

    var doorWidthRealId = 1;
    var standbackId = 1;
    for (var index = 2; index < doorWidthReals * standbacks + 2; index++) {
      var value = parseFloat(lines[index].split(";")[2].replace(",", "."));
      for (
        var index3 = 0;
        index3 < this.regionData.doorWidthReduction.values.length;
        index3++
      ) {
        const element = this.regionData.doorWidthReduction.values[index3];
        if (
          element.doorWidthRealId == doorWidthRealId &&
          element.standbackId == standbackId
        ) {
          this.regionData.doorWidthReduction.values[index3].value = value;
          break;
        }
      }

      if (standbackId == 5) {
        standbackId = 0;
        doorWidthRealId++;
      }
      standbackId++;
    }
  }
  splitTabDoorWidthAndPhysicalSeparationFactor(text: string) {
    var doorWidthCalculated: number = 22;
    var lines = text.split(BACKSLASH_N);

    var doorWidthCalculatedId = 1;
    for (var index = 2; index < doorWidthCalculated + 2; index++) {
      var noSeperationValue = parseFloat(
        lines[index].split(";")[1].replace(",", ".")
      );
      var oneSeperationValue = parseFloat(
        lines[index].split(";")[2].replace(",", ".")
      );
      var twoSeperationValue = parseFloat(
        lines[index].split(";")[3].replace(",", ".")
      );

      for (
        var index3 = 0;
        index3 <
        this.regionData.doorWidthAndPhysicalSeparationFactor.values.length;
        index3++
      ) {
        const element =
          this.regionData.doorWidthAndPhysicalSeparationFactor.values[index3];
        if (element.doorWidthCalculatedId == doorWidthCalculatedId) {
          this.regionData.doorWidthAndPhysicalSeparationFactor.values[
            index3
          ].noSeparationValue = noSeperationValue;
          this.regionData.doorWidthAndPhysicalSeparationFactor.values[
            index3
          ].oneSeparationValue = oneSeperationValue;
          this.regionData.doorWidthAndPhysicalSeparationFactor.values[
            index3
          ].twoSeparationsValue = twoSeperationValue;
          break;
        }
      }
      doorWidthCalculatedId++;
    }
  }
  splitFactorSet(text: string) {
    //for BaseValueTime, BaseFactor and PolynomialFactor
    var factorSetsAmount: number = 3;
    var lines = text.split(BACKSLASH_N);
    var factorSetNumber = 1;
    for (var index = 4; index < factorSetsAmount + 4; index++) {
      var longDistanceTransportDeboardingValue = parseFloat(
        lines[index].split(";")[2].replace(",", ".")
      );
      var longDistanceTransportBoarding1Value = parseFloat(
        lines[index].split(";")[3].replace(",", ".")
      );
      var longDistanceTransportBoarding2Value = parseFloat(
        lines[index].split(";")[4].replace(",", ".")
      );

      var regionalPublicTransportDeboardingValue = parseFloat(
        lines[index].split(";")[5].replace(",", ".")
      );
      var regionalPublicTransportBoarding1Value = parseFloat(
        lines[index].split(";")[6].replace(",", ".")
      );
      var regionalPublicTransportBoarding2Value = parseFloat(
        lines[index].split(";")[7].replace(",", ".")
      );

      var urbanPublicTransportDeboardingValue = parseFloat(
        lines[index].split(";")[8].replace(",", ".")
      );
      var urbanPublicTransportBoarding1Value = parseFloat(
        lines[index].split(";")[9].replace(",", ".")
      );
      var urbanPublicTransportBoarding2Value = parseFloat(
        lines[index].split(";")[10].replace(",", ".")
      );

      if (factorSetNumber == 1) {
        for (
          var index2 = 0;
          index2 < this.regionData.baseValueTime.values.length;
          index2++
        ) {
          const element = this.regionData.baseValueTime.values[index2];
          if (element.transportModeId == 3) {
            this.regionData.baseValueTime.values[index2].deboardingValue =
              longDistanceTransportDeboardingValue;
            this.regionData.baseValueTime.values[index2].boarding1Value =
              longDistanceTransportBoarding1Value;
            this.regionData.baseValueTime.values[index2].boarding2Value =
              longDistanceTransportBoarding2Value;
          }
          if (element.transportModeId == 2) {
            this.regionData.baseValueTime.values[index2].deboardingValue =
              regionalPublicTransportDeboardingValue;
            this.regionData.baseValueTime.values[index2].boarding1Value =
              regionalPublicTransportBoarding1Value;
            this.regionData.baseValueTime.values[index2].boarding2Value =
              regionalPublicTransportBoarding2Value;
          }
          if (element.transportModeId == 1) {
            this.regionData.baseValueTime.values[index2].deboardingValue =
              urbanPublicTransportDeboardingValue;
            this.regionData.baseValueTime.values[index2].boarding1Value =
              urbanPublicTransportBoarding1Value;
            this.regionData.baseValueTime.values[index2].boarding2Value =
              urbanPublicTransportBoarding2Value;
          }
        }
      }
      if (factorSetNumber == 2) {
        for (
          var index2 = 0;
          index2 < this.regionData.baseFactor.values.length;
          index2++
        ) {
          const element = this.regionData.baseFactor.values[index2];
          if (element.transportModeId == 3) {
            this.regionData.baseFactor.values[index2].deboardingValue =
              longDistanceTransportDeboardingValue;
            this.regionData.baseFactor.values[index2].boarding1Value =
              longDistanceTransportBoarding1Value;
            this.regionData.baseFactor.values[index2].boarding2Value =
              longDistanceTransportBoarding2Value;
          }
          if (element.transportModeId == 2) {
            this.regionData.baseFactor.values[index2].deboardingValue =
              regionalPublicTransportDeboardingValue;
            this.regionData.baseFactor.values[index2].boarding1Value =
              regionalPublicTransportBoarding1Value;
            this.regionData.baseFactor.values[index2].boarding2Value =
              regionalPublicTransportBoarding2Value;
          }
          if (element.transportModeId == 1) {
            this.regionData.baseFactor.values[index2].deboardingValue =
              urbanPublicTransportDeboardingValue;
            this.regionData.baseFactor.values[index2].boarding1Value =
              urbanPublicTransportBoarding1Value;
            this.regionData.baseFactor.values[index2].boarding2Value =
              urbanPublicTransportBoarding2Value;
          }
        }
      }
      if (factorSetNumber == 3) {
        for (
          var index2 = 0;
          index2 < this.regionData.polynomialFactor.values.length;
          index2++
        ) {
          const element = this.regionData.polynomialFactor.values[index2];
          if (element.transportModeId == 3) {
            this.regionData.polynomialFactor.values[index2].deboardingValue =
              longDistanceTransportDeboardingValue;
            this.regionData.polynomialFactor.values[index2].boarding1Value =
              longDistanceTransportBoarding1Value;
            this.regionData.polynomialFactor.values[index2].boarding2Value =
              longDistanceTransportBoarding2Value;
          }
          if (element.transportModeId == 2) {
            this.regionData.polynomialFactor.values[index2].deboardingValue =
              regionalPublicTransportDeboardingValue;
            this.regionData.polynomialFactor.values[index2].boarding1Value =
              regionalPublicTransportBoarding1Value;
            this.regionData.polynomialFactor.values[index2].boarding2Value =
              regionalPublicTransportBoarding2Value;
          }
          if (element.transportModeId == 1) {
            this.regionData.polynomialFactor.values[index2].deboardingValue =
              urbanPublicTransportDeboardingValue;
            this.regionData.polynomialFactor.values[index2].boarding1Value =
              urbanPublicTransportBoarding1Value;
            this.regionData.polynomialFactor.values[index2].boarding2Value =
              urbanPublicTransportBoarding2Value;
          }
        }
      }
      factorSetNumber++;
    }
  }
  splitTabAisleWidth(text: string) {
    var averageAisleWidthIds: number = 25;
    var lines = text.split(BACKSLASH_N);

    var averageAisleWidthId = 1;
    for (var index = 4; index < averageAisleWidthIds + 4; index++) {
      var longDistanceTransportDeboardingValue = parseFloat(
        lines[index].split(";")[1].replace(",", ".")
      );
      var longDistanceTransportBoarding1Value = parseFloat(
        lines[index].split(";")[2].replace(",", ".")
      );
      var longDistanceTransportBoarding2Value = parseFloat(
        lines[index].split(";")[3].replace(",", ".")
      );

      var regionalPublicTransportDeboardingValue = parseFloat(
        lines[index].split(";")[4].replace(",", ".")
      );
      var regionalPublicTransportBoarding1Value = parseFloat(
        lines[index].split(";")[5].replace(",", ".")
      );
      var regionalPublicTransportBoarding2Value = parseFloat(
        lines[index].split(";")[6].replace(",", ".")
      );

      var urbanPublicTransportDeboardingValue = parseFloat(
        lines[index].split(";")[7].replace(",", ".")
      );
      var urbanPublicTransportBoarding1Value = parseFloat(
        lines[index].split(";")[8].replace(",", ".")
      );
      var urbanPublicTransportBoarding2Value = parseFloat(
        lines[index].split(";")[9].replace(",", ".")
      );

      for (
        var index2 = 0;
        index2 < this.regionData.aisleWidth.values.length;
        index2++
      ) {
        const element = this.regionData.aisleWidth.values[index2];
        if (
          element.transportModeId == 3 &&
          element.additionalId == averageAisleWidthId
        ) {
          this.regionData.aisleWidth.values[index2].deboardingValue =
            longDistanceTransportDeboardingValue;
          this.regionData.aisleWidth.values[index2].boarding1Value =
            longDistanceTransportBoarding1Value;
          this.regionData.aisleWidth.values[index2].boarding2Value =
            longDistanceTransportBoarding2Value;
        }
        if (
          element.transportModeId == 2 &&
          element.additionalId == averageAisleWidthId
        ) {
          this.regionData.aisleWidth.values[index2].deboardingValue =
            regionalPublicTransportDeboardingValue;
          this.regionData.aisleWidth.values[index2].boarding1Value =
            regionalPublicTransportBoarding1Value;
          this.regionData.aisleWidth.values[index2].boarding2Value =
            regionalPublicTransportBoarding2Value;
        }
        if (
          element.transportModeId == 1 &&
          element.additionalId == averageAisleWidthId
        ) {
          this.regionData.aisleWidth.values[index2].deboardingValue =
            urbanPublicTransportDeboardingValue;
          this.regionData.aisleWidth.values[index2].boarding1Value =
            urbanPublicTransportBoarding1Value;
          this.regionData.aisleWidth.values[index2].boarding2Value =
            urbanPublicTransportBoarding2Value;
        }
      }
      averageAisleWidthId++;
    }
  }
  splitTabAlternativeRooms(text: string) {
    var alternativeRoomsFactors: number = 5;
    var lines = text.split(BACKSLASH_N);

    var alternativeRoomsFactorId = 1;
    for (var index = 4; index < alternativeRoomsFactors + 4; index++) {
      var longDistanceTransportDeboardingValue = parseFloat(
        lines[index].split(";")[1].replace(",", ".")
      );
      var longDistanceTransportBoarding1Value = parseFloat(
        lines[index].split(";")[2].replace(",", ".")
      );
      var longDistanceTransportBoarding2Value = parseFloat(
        lines[index].split(";")[3].replace(",", ".")
      );

      var regionalPublicTransportDeboardingValue = parseFloat(
        lines[index].split(";")[4].replace(",", ".")
      );
      var regionalPublicTransportBoarding1Value = parseFloat(
        lines[index].split(";")[5].replace(",", ".")
      );
      var regionalPublicTransportBoarding2Value = parseFloat(
        lines[index].split(";")[6].replace(",", ".")
      );

      var urbanPublicTransportDeboardingValue = parseFloat(
        lines[index].split(";")[7].replace(",", ".")
      );
      var urbanPublicTransportBoarding1Value = parseFloat(
        lines[index].split(";")[8].replace(",", ".")
      );
      var urbanPublicTransportBoarding2Value = parseFloat(
        lines[index].split(";")[9].replace(",", ".")
      );

      for (
        var index2 = 0;
        index2 < this.regionData.alternativeRooms.values.length;
        index2++
      ) {
        const element = this.regionData.alternativeRooms.values[index2];
        if (
          element.transportModeId == 3 &&
          element.additionalId == alternativeRoomsFactorId
        ) {
          this.regionData.alternativeRooms.values[index2].deboardingValue =
            longDistanceTransportDeboardingValue;
          this.regionData.alternativeRooms.values[index2].boarding1Value =
            longDistanceTransportBoarding1Value;
          this.regionData.alternativeRooms.values[index2].boarding2Value =
            longDistanceTransportBoarding2Value;
        }
        if (
          element.transportModeId == 2 &&
          element.additionalId == alternativeRoomsFactorId
        ) {
          this.regionData.alternativeRooms.values[index2].deboardingValue =
            regionalPublicTransportDeboardingValue;
          this.regionData.alternativeRooms.values[index2].boarding1Value =
            regionalPublicTransportBoarding1Value;
          this.regionData.alternativeRooms.values[index2].boarding2Value =
            regionalPublicTransportBoarding2Value;
        }
        if (
          element.transportModeId == 1 &&
          element.additionalId == alternativeRoomsFactorId
        ) {
          this.regionData.alternativeRooms.values[index2].deboardingValue =
            urbanPublicTransportDeboardingValue;
          this.regionData.alternativeRooms.values[index2].boarding1Value =
            urbanPublicTransportBoarding1Value;
          this.regionData.alternativeRooms.values[index2].boarding2Value =
            urbanPublicTransportBoarding2Value;
        }
      }
      alternativeRoomsFactorId++;
    }
  }
  splitTabAccessibilityOfTheSeatsFactor(text: string) {
    var accessibilityOfTheSeatsFactors: number = 6;
    var lines = text.split(BACKSLASH_N);

    var accessibilityOfTheSeatsFactorId = 1;
    for (var index = 4; index < accessibilityOfTheSeatsFactors + 4; index++) {
      var longDistanceTransportDeboardingValue = parseFloat(
        lines[index].split(";")[1].replace(",", ".")
      );
      var longDistanceTransportBoarding1Value = parseFloat(
        lines[index].split(";")[2].replace(",", ".")
      );
      var longDistanceTransportBoarding2Value = parseFloat(
        lines[index].split(";")[3].replace(",", ".")
      );

      var regionalPublicTransportDeboardingValue = parseFloat(
        lines[index].split(";")[4].replace(",", ".")
      );
      var regionalPublicTransportBoarding1Value = parseFloat(
        lines[index].split(";")[5].replace(",", ".")
      );
      var regionalPublicTransportBoarding2Value = parseFloat(
        lines[index].split(";")[6].replace(",", ".")
      );

      var urbanPublicTransportDeboardingValue = parseFloat(
        lines[index].split(";")[7].replace(",", ".")
      );
      var urbanPublicTransportBoarding1Value = parseFloat(
        lines[index].split(";")[8].replace(",", ".")
      );
      var urbanPublicTransportBoarding2Value = parseFloat(
        lines[index].split(";")[9].replace(",", ".")
      );

      for (
        var index2 = 0;
        index2 < this.regionData.accessibilityOfTheSeats.values.length;
        index2++
      ) {
        const element = this.regionData.accessibilityOfTheSeats.values[index2];
        if (
          element.transportModeId == 3 &&
          element.additionalId == accessibilityOfTheSeatsFactorId
        ) {
          this.regionData.accessibilityOfTheSeats.values[
            index2
          ].deboardingValue = longDistanceTransportDeboardingValue;
          this.regionData.accessibilityOfTheSeats.values[
            index2
          ].boarding1Value = longDistanceTransportBoarding1Value;
          this.regionData.accessibilityOfTheSeats.values[
            index2
          ].boarding2Value = longDistanceTransportBoarding2Value;
        }
        if (
          element.transportModeId == 2 &&
          element.additionalId == accessibilityOfTheSeatsFactorId
        ) {
          this.regionData.accessibilityOfTheSeats.values[
            index2
          ].deboardingValue = regionalPublicTransportDeboardingValue;
          this.regionData.accessibilityOfTheSeats.values[
            index2
          ].boarding1Value = regionalPublicTransportBoarding1Value;
          this.regionData.accessibilityOfTheSeats.values[
            index2
          ].boarding2Value = regionalPublicTransportBoarding2Value;
        }
        if (
          element.transportModeId == 1 &&
          element.additionalId == accessibilityOfTheSeatsFactorId
        ) {
          this.regionData.accessibilityOfTheSeats.values[
            index2
          ].deboardingValue = urbanPublicTransportDeboardingValue;
          this.regionData.accessibilityOfTheSeats.values[
            index2
          ].boarding1Value = urbanPublicTransportBoarding1Value;
          this.regionData.accessibilityOfTheSeats.values[
            index2
          ].boarding2Value = urbanPublicTransportBoarding2Value;
        }
      }
      accessibilityOfTheSeatsFactorId++;
    }
  }
  splitTabAmountOfNotStorableBaggage(text: string) {
    var notStorableBaggageFactors: number = 10;
    var lines = text.split(BACKSLASH_N);

    var notStorableBaggageFactorId = 1;
    for (var index = 4; index < notStorableBaggageFactors + 4; index++) {
      var longDistanceTransportDeboardingValue = parseFloat(
        lines[index].split(";")[1].replace(",", ".")
      );
      var longDistanceTransportBoarding1Value = parseFloat(
        lines[index].split(";")[2].replace(",", ".")
      );
      var longDistanceTransportBoarding2Value = parseFloat(
        lines[index].split(";")[3].replace(",", ".")
      );

      var regionalPublicTransportDeboardingValue = parseFloat(
        lines[index].split(";")[4].replace(",", ".")
      );
      var regionalPublicTransportBoarding1Value = parseFloat(
        lines[index].split(";")[5].replace(",", ".")
      );
      var regionalPublicTransportBoarding2Value = parseFloat(
        lines[index].split(";")[6].replace(",", ".")
      );

      var urbanPublicTransportDeboardingValue = parseFloat(
        lines[index].split(";")[7].replace(",", ".")
      );
      var urbanPublicTransportBoarding1Value = parseFloat(
        lines[index].split(";")[8].replace(",", ".")
      );
      var urbanPublicTransportBoarding2Value = parseFloat(
        lines[index].split(";")[9].replace(",", ".")
      );

      for (
        var index2 = 0;
        index2 < this.regionData.amountOfNotStorableBaggage.values.length;
        index2++
      ) {
        const element =
          this.regionData.amountOfNotStorableBaggage.values[index2];
        if (
          element.transportModeId == 3 &&
          element.additionalId == notStorableBaggageFactorId
        ) {
          this.regionData.amountOfNotStorableBaggage.values[
            index2
          ].deboardingValue = longDistanceTransportDeboardingValue;
          this.regionData.amountOfNotStorableBaggage.values[
            index2
          ].boarding1Value = longDistanceTransportBoarding1Value;
          this.regionData.amountOfNotStorableBaggage.values[
            index2
          ].boarding2Value = longDistanceTransportBoarding2Value;
        }
        if (
          element.transportModeId == 2 &&
          element.additionalId == notStorableBaggageFactorId
        ) {
          this.regionData.amountOfNotStorableBaggage.values[
            index2
          ].deboardingValue = regionalPublicTransportDeboardingValue;
          this.regionData.amountOfNotStorableBaggage.values[
            index2
          ].boarding1Value = regionalPublicTransportBoarding1Value;
          this.regionData.amountOfNotStorableBaggage.values[
            index2
          ].boarding2Value = regionalPublicTransportBoarding2Value;
        }
        if (
          element.transportModeId == 1 &&
          element.additionalId == notStorableBaggageFactorId
        ) {
          this.regionData.amountOfNotStorableBaggage.values[
            index2
          ].deboardingValue = urbanPublicTransportDeboardingValue;
          this.regionData.amountOfNotStorableBaggage.values[
            index2
          ].boarding1Value = urbanPublicTransportBoarding1Value;
          this.regionData.amountOfNotStorableBaggage.values[
            index2
          ].boarding2Value = urbanPublicTransportBoarding2Value;
        }
      }
      notStorableBaggageFactorId++;
    }
  }
  splitTabSimplicityLuggageAccommodation(text: string) {
    var simplicityLuggageAccommodationFactors: number = 10;
    var lines = text.split(BACKSLASH_N);

    var simplicityLuggageAccommodationFactorId = 1;
    for (
      var index = 4;
      index < simplicityLuggageAccommodationFactors + 4;
      index++
    ) {
      var longDistanceTransportDeboardingValue = parseFloat(
        lines[index].split(";")[1].replace(",", ".")
      );
      var longDistanceTransportBoarding1Value = parseFloat(
        lines[index].split(";")[2].replace(",", ".")
      );
      var longDistanceTransportBoarding2Value = parseFloat(
        lines[index].split(";")[3].replace(",", ".")
      );

      var regionalPublicTransportDeboardingValue = parseFloat(
        lines[index].split(";")[4].replace(",", ".")
      );
      var regionalPublicTransportBoarding1Value = parseFloat(
        lines[index].split(";")[5].replace(",", ".")
      );
      var regionalPublicTransportBoarding2Value = parseFloat(
        lines[index].split(";")[6].replace(",", ".")
      );

      var urbanPublicTransportDeboardingValue = parseFloat(
        lines[index].split(";")[7].replace(",", ".")
      );
      var urbanPublicTransportBoarding1Value = parseFloat(
        lines[index].split(";")[8].replace(",", ".")
      );
      var urbanPublicTransportBoarding2Value = parseFloat(
        lines[index].split(";")[9].replace(",", ".")
      );

      for (
        var index2 = 0;
        index2 < this.regionData.simplicityLuggageAccommodation.values.length;
        index2++
      ) {
        const element =
          this.regionData.simplicityLuggageAccommodation.values[index2];
        if (
          element.transportModeId == 3 &&
          element.additionalId == simplicityLuggageAccommodationFactorId
        ) {
          this.regionData.simplicityLuggageAccommodation.values[
            index2
          ].deboardingValue = longDistanceTransportDeboardingValue;
          this.regionData.simplicityLuggageAccommodation.values[
            index2
          ].boarding1Value = longDistanceTransportBoarding1Value;
          this.regionData.simplicityLuggageAccommodation.values[
            index2
          ].boarding2Value = longDistanceTransportBoarding2Value;
        }
        if (
          element.transportModeId == 2 &&
          element.additionalId == simplicityLuggageAccommodationFactorId
        ) {
          this.regionData.simplicityLuggageAccommodation.values[
            index2
          ].deboardingValue = regionalPublicTransportDeboardingValue;
          this.regionData.simplicityLuggageAccommodation.values[
            index2
          ].boarding1Value = regionalPublicTransportBoarding1Value;
          this.regionData.simplicityLuggageAccommodation.values[
            index2
          ].boarding2Value = regionalPublicTransportBoarding2Value;
        }
        if (
          element.transportModeId == 1 &&
          element.additionalId == simplicityLuggageAccommodationFactorId
        ) {
          this.regionData.simplicityLuggageAccommodation.values[
            index2
          ].deboardingValue = urbanPublicTransportDeboardingValue;
          this.regionData.simplicityLuggageAccommodation.values[
            index2
          ].boarding1Value = urbanPublicTransportBoarding1Value;
          this.regionData.simplicityLuggageAccommodation.values[
            index2
          ].boarding2Value = urbanPublicTransportBoarding2Value;
        }
      }
      simplicityLuggageAccommodationFactorId++;
    }
  }
  splitTabLuggageRacksWhenBoarding(text: string) {
    var falseTrueFactors: number = 2;
    var lines = text.split(BACKSLASH_N);

    var falseOrTrue = 0;
    for (var index = 4; index < falseTrueFactors + 4; index++) {
      var longDistanceTransportDeboardingValue = parseFloat(
        lines[index].split(";")[1].replace(",", ".")
      );
      var longDistanceTransportBoarding1Value = parseFloat(
        lines[index].split(";")[2].replace(",", ".")
      );
      var longDistanceTransportBoarding2Value = parseFloat(
        lines[index].split(";")[3].replace(",", ".")
      );

      var regionalPublicTransportDeboardingValue = parseFloat(
        lines[index].split(";")[4].replace(",", ".")
      );
      var regionalPublicTransportBoarding1Value = parseFloat(
        lines[index].split(";")[5].replace(",", ".")
      );
      var regionalPublicTransportBoarding2Value = parseFloat(
        lines[index].split(";")[6].replace(",", ".")
      );

      var urbanPublicTransportDeboardingValue = parseFloat(
        lines[index].split(";")[7].replace(",", ".")
      );
      var urbanPublicTransportBoarding1Value = parseFloat(
        lines[index].split(";")[8].replace(",", ".")
      );
      var urbanPublicTransportBoarding2Value = parseFloat(
        lines[index].split(";")[9].replace(",", ".")
      );

      for (
        var index2 = 0;
        index2 < this.regionData.luggageRacksWhenBoarding.values.length;
        index2++
      ) {
        const element = this.regionData.luggageRacksWhenBoarding.values[index2];
        if (
          element.transportModeId == 3 &&
          element.additionalBoolean == !!falseOrTrue
        ) {
          this.regionData.luggageRacksWhenBoarding.values[
            index2
          ].deboardingValue = longDistanceTransportDeboardingValue;
          this.regionData.luggageRacksWhenBoarding.values[
            index2
          ].boarding1Value = longDistanceTransportBoarding1Value;
          this.regionData.luggageRacksWhenBoarding.values[
            index2
          ].boarding2Value = longDistanceTransportBoarding2Value;
        }
        if (
          element.transportModeId == 2 &&
          element.additionalBoolean == !!falseOrTrue
        ) {
          this.regionData.luggageRacksWhenBoarding.values[
            index2
          ].deboardingValue = regionalPublicTransportDeboardingValue;
          this.regionData.luggageRacksWhenBoarding.values[
            index2
          ].boarding1Value = regionalPublicTransportBoarding1Value;
          this.regionData.luggageRacksWhenBoarding.values[
            index2
          ].boarding2Value = regionalPublicTransportBoarding2Value;
        }
        if (
          element.transportModeId == 1 &&
          element.additionalBoolean == !!falseOrTrue
        ) {
          this.regionData.luggageRacksWhenBoarding.values[
            index2
          ].deboardingValue = urbanPublicTransportDeboardingValue;
          this.regionData.luggageRacksWhenBoarding.values[
            index2
          ].boarding1Value = urbanPublicTransportBoarding1Value;
          this.regionData.luggageRacksWhenBoarding.values[
            index2
          ].boarding2Value = urbanPublicTransportBoarding2Value;
        }
      }
      falseOrTrue++;
    }
  }
  splitTabBaggageAccumulation(text: string) {
    var baggageAccumulationFactors: number = 13;
    var lines = text.split(BACKSLASH_N);

    var baggageAccumulationFactorId = 1;
    for (var index = 4; index < baggageAccumulationFactors + 4; index++) {
      var longDistanceTransportDeboardingValue = parseFloat(
        lines[index].split(";")[1].replace(",", ".")
      );
      var longDistanceTransportBoarding1Value = parseFloat(
        lines[index].split(";")[2].replace(",", ".")
      );
      var longDistanceTransportBoarding2Value = parseFloat(
        lines[index].split(";")[3].replace(",", ".")
      );

      var regionalPublicTransportDeboardingValue = parseFloat(
        lines[index].split(";")[4].replace(",", ".")
      );
      var regionalPublicTransportBoarding1Value = parseFloat(
        lines[index].split(";")[5].replace(",", ".")
      );
      var regionalPublicTransportBoarding2Value = parseFloat(
        lines[index].split(";")[6].replace(",", ".")
      );

      var urbanPublicTransportDeboardingValue = parseFloat(
        lines[index].split(";")[7].replace(",", ".")
      );
      var urbanPublicTransportBoarding1Value = parseFloat(
        lines[index].split(";")[8].replace(",", ".")
      );
      var urbanPublicTransportBoarding2Value = parseFloat(
        lines[index].split(";")[9].replace(",", ".")
      );

      for (
        var index2 = 0;
        index2 < this.regionData.baggageAccumulation.values.length;
        index2++
      ) {
        const element = this.regionData.baggageAccumulation.values[index2];
        if (
          element.transportModeId == 3 &&
          element.additionalId == baggageAccumulationFactorId
        ) {
          this.regionData.baggageAccumulation.values[index2].deboardingValue =
            longDistanceTransportDeboardingValue;
          this.regionData.baggageAccumulation.values[index2].boarding1Value =
            longDistanceTransportBoarding1Value;
          this.regionData.baggageAccumulation.values[index2].boarding2Value =
            longDistanceTransportBoarding2Value;
        }
        if (
          element.transportModeId == 2 &&
          element.additionalId == baggageAccumulationFactorId
        ) {
          this.regionData.baggageAccumulation.values[index2].deboardingValue =
            regionalPublicTransportDeboardingValue;
          this.regionData.baggageAccumulation.values[index2].boarding1Value =
            regionalPublicTransportBoarding1Value;
          this.regionData.baggageAccumulation.values[index2].boarding2Value =
            regionalPublicTransportBoarding2Value;
        }
        if (
          element.transportModeId == 1 &&
          element.additionalId == baggageAccumulationFactorId
        ) {
          this.regionData.baggageAccumulation.values[index2].deboardingValue =
            urbanPublicTransportDeboardingValue;
          this.regionData.baggageAccumulation.values[index2].boarding1Value =
            urbanPublicTransportBoarding1Value;
          this.regionData.baggageAccumulation.values[index2].boarding2Value =
            urbanPublicTransportBoarding2Value;
        }
      }
      baggageAccumulationFactorId++;
    }
  }
  splitTabReservationObligation(text: string) {
    var falseTrueFactors: number = 2;
    var lines = text.split(BACKSLASH_N);

    var trueOrFalse = 1;
    for (var index = 4; index < falseTrueFactors + 4; index++) {
      var longDistanceTransportDeboardingValue = parseFloat(
        lines[index].split(";")[1].replace(",", ".")
      );
      var longDistanceTransportBoarding1Value = parseFloat(
        lines[index].split(";")[2].replace(",", ".")
      );
      var longDistanceTransportBoarding2Value = parseFloat(
        lines[index].split(";")[3].replace(",", ".")
      );

      var regionalPublicTransportDeboardingValue = parseFloat(
        lines[index].split(";")[4].replace(",", ".")
      );
      var regionalPublicTransportBoarding1Value = parseFloat(
        lines[index].split(";")[5].replace(",", ".")
      );
      var regionalPublicTransportBoarding2Value = parseFloat(
        lines[index].split(";")[6].replace(",", ".")
      );

      var urbanPublicTransportDeboardingValue = parseFloat(
        lines[index].split(";")[7].replace(",", ".")
      );
      var urbanPublicTransportBoarding1Value = parseFloat(
        lines[index].split(";")[8].replace(",", ".")
      );
      var urbanPublicTransportBoarding2Value = parseFloat(
        lines[index].split(";")[9].replace(",", ".")
      );

      for (
        var index2 = 0;
        index2 < this.regionData.reservationObligation.values.length;
        index2++
      ) {
        const element = this.regionData.reservationObligation.values[index2];
        if (
          element.transportModeId == 3 &&
          element.additionalBoolean == !!trueOrFalse
        ) {
          this.regionData.reservationObligation.values[index2].deboardingValue =
            longDistanceTransportDeboardingValue;
          this.regionData.reservationObligation.values[index2].boarding1Value =
            longDistanceTransportBoarding1Value;
          this.regionData.reservationObligation.values[index2].boarding2Value =
            longDistanceTransportBoarding2Value;
        }
        if (
          element.transportModeId == 2 &&
          element.additionalBoolean == !!trueOrFalse
        ) {
          this.regionData.reservationObligation.values[index2].deboardingValue =
            regionalPublicTransportDeboardingValue;
          this.regionData.reservationObligation.values[index2].boarding1Value =
            regionalPublicTransportBoarding1Value;
          this.regionData.reservationObligation.values[index2].boarding2Value =
            regionalPublicTransportBoarding2Value;
        }
        if (
          element.transportModeId == 1 &&
          element.additionalBoolean == !!trueOrFalse
        ) {
          this.regionData.reservationObligation.values[index2].deboardingValue =
            urbanPublicTransportDeboardingValue;
          this.regionData.reservationObligation.values[index2].boarding1Value =
            urbanPublicTransportBoarding1Value;
          this.regionData.reservationObligation.values[index2].boarding2Value =
            urbanPublicTransportBoarding2Value;
        }
      }
      trueOrFalse--;
    }
  }
  splitTabCompartmentsAvailable(text: string) {
    var falseTrueFactors: number = 2;
    var lines = text.split(BACKSLASH_N);

    var trueOrFalse = 1;
    for (var index = 4; index < falseTrueFactors + 4; index++) {
      var longDistanceTransportDeboardingValue = parseFloat(
        lines[index].split(";")[1].replace(",", ".")
      );
      var longDistanceTransportBoarding1Value = parseFloat(
        lines[index].split(";")[2].replace(",", ".")
      );
      var longDistanceTransportBoarding2Value = parseFloat(
        lines[index].split(";")[3].replace(",", ".")
      );

      var regionalPublicTransportDeboardingValue = parseFloat(
        lines[index].split(";")[4].replace(",", ".")
      );
      var regionalPublicTransportBoarding1Value = parseFloat(
        lines[index].split(";")[5].replace(",", ".")
      );
      var regionalPublicTransportBoarding2Value = parseFloat(
        lines[index].split(";")[6].replace(",", ".")
      );

      var urbanPublicTransportDeboardingValue = parseFloat(
        lines[index].split(";")[7].replace(",", ".")
      );
      var urbanPublicTransportBoarding1Value = parseFloat(
        lines[index].split(";")[8].replace(",", ".")
      );
      var urbanPublicTransportBoarding2Value = parseFloat(
        lines[index].split(";")[9].replace(",", ".")
      );

      for (
        var index2 = 0;
        index2 < this.regionData.compartmentsAvailable.values.length;
        index2++
      ) {
        const element = this.regionData.compartmentsAvailable.values[index2];
        if (
          element.transportModeId == 3 &&
          element.additionalBoolean == !!trueOrFalse
        ) {
          this.regionData.compartmentsAvailable.values[index2].deboardingValue =
            longDistanceTransportDeboardingValue;
          this.regionData.compartmentsAvailable.values[index2].boarding1Value =
            longDistanceTransportBoarding1Value;
          this.regionData.compartmentsAvailable.values[index2].boarding2Value =
            longDistanceTransportBoarding2Value;
        }
        if (
          element.transportModeId == 2 &&
          element.additionalBoolean == !!trueOrFalse
        ) {
          this.regionData.compartmentsAvailable.values[index2].deboardingValue =
            regionalPublicTransportDeboardingValue;
          this.regionData.compartmentsAvailable.values[index2].boarding1Value =
            regionalPublicTransportBoarding1Value;
          this.regionData.compartmentsAvailable.values[index2].boarding2Value =
            regionalPublicTransportBoarding2Value;
        }
        if (
          element.transportModeId == 1 &&
          element.additionalBoolean == !!trueOrFalse
        ) {
          this.regionData.compartmentsAvailable.values[index2].deboardingValue =
            urbanPublicTransportDeboardingValue;
          this.regionData.compartmentsAvailable.values[index2].boarding1Value =
            urbanPublicTransportBoarding1Value;
          this.regionData.compartmentsAvailable.values[index2].boarding2Value =
            urbanPublicTransportBoarding2Value;
        }
      }
      trueOrFalse--;
    }
  }
  splitTabSeatsPerRunningMeter(text: string) {
    var seatsPerRunningMeterFactors: number = 13;
    var lines = text.split(BACKSLASH_N);

    var seatsPerRunningMeterFactorId = 1;
    for (var index = 4; index < seatsPerRunningMeterFactors + 4; index++) {
      var longDistanceTransportDeboardingValue = parseFloat(
        lines[index].split(";")[1].replace(",", ".")
      );
      var longDistanceTransportBoarding1Value = parseFloat(
        lines[index].split(";")[2].replace(",", ".")
      );
      var longDistanceTransportBoarding2Value = parseFloat(
        lines[index].split(";")[3].replace(",", ".")
      );

      var regionalPublicTransportDeboardingValue = parseFloat(
        lines[index].split(";")[4].replace(",", ".")
      );
      var regionalPublicTransportBoarding1Value = parseFloat(
        lines[index].split(";")[5].replace(",", ".")
      );
      var regionalPublicTransportBoarding2Value = parseFloat(
        lines[index].split(";")[6].replace(",", ".")
      );

      var urbanPublicTransportDeboardingValue = parseFloat(
        lines[index].split(";")[7].replace(",", ".")
      );
      var urbanPublicTransportBoarding1Value = parseFloat(
        lines[index].split(";")[8].replace(",", ".")
      );
      var urbanPublicTransportBoarding2Value = parseFloat(
        lines[index].split(";")[9].replace(",", ".")
      );

      for (
        var index2 = 0;
        index2 < this.regionData.seatsPerRunningMeter.values.length;
        index2++
      ) {
        const element = this.regionData.seatsPerRunningMeter.values[index2];
        if (
          element.transportModeId == 3 &&
          element.additionalId == seatsPerRunningMeterFactorId
        ) {
          this.regionData.seatsPerRunningMeter.values[index2].deboardingValue =
            longDistanceTransportDeboardingValue;
          this.regionData.seatsPerRunningMeter.values[index2].boarding1Value =
            longDistanceTransportBoarding1Value;
          this.regionData.seatsPerRunningMeter.values[index2].boarding2Value =
            longDistanceTransportBoarding2Value;
        }
        if (
          element.transportModeId == 2 &&
          element.additionalId == seatsPerRunningMeterFactorId
        ) {
          this.regionData.seatsPerRunningMeter.values[index2].deboardingValue =
            regionalPublicTransportDeboardingValue;
          this.regionData.seatsPerRunningMeter.values[index2].boarding1Value =
            regionalPublicTransportBoarding1Value;
          this.regionData.seatsPerRunningMeter.values[index2].boarding2Value =
            regionalPublicTransportBoarding2Value;
        }
        if (
          element.transportModeId == 1 &&
          element.additionalId == seatsPerRunningMeterFactorId
        ) {
          this.regionData.seatsPerRunningMeter.values[index2].deboardingValue =
            urbanPublicTransportDeboardingValue;
          this.regionData.seatsPerRunningMeter.values[index2].boarding1Value =
            urbanPublicTransportBoarding1Value;
          this.regionData.seatsPerRunningMeter.values[index2].boarding2Value =
            urbanPublicTransportBoarding2Value;
        }
      }
      seatsPerRunningMeterFactorId++;
    }
  }
  splitTabAgeDistribution(text: string) {
    var ageGenders: number = 12;
    var lines = text.split(BACKSLASH_N);

    var ageGenderId = 0;
    for (var index = 4; index < ageGenders + 4; index++) {
      var longDistanceTransportDeboardingValue = parseFloat(
        lines[index].split(";")[1].replace(",", ".")
      );
      var longDistanceTransportBoarding1Value = parseFloat(
        lines[index].split(";")[2].replace(",", ".")
      );
      var longDistanceTransportBoarding2Value = parseFloat(
        lines[index].split(";")[3].replace(",", ".")
      );

      var regionalPublicTransportDeboardingValue = parseFloat(
        lines[index].split(";")[4].replace(",", ".")
      );
      var regionalPublicTransportBoarding1Value = parseFloat(
        lines[index].split(";")[5].replace(",", ".")
      );
      var regionalPublicTransportBoarding2Value = parseFloat(
        lines[index].split(";")[6].replace(",", ".")
      );

      var urbanPublicTransportDeboardingValue = parseFloat(
        lines[index].split(";")[7].replace(",", ".")
      );
      var urbanPublicTransportBoarding1Value = parseFloat(
        lines[index].split(";")[8].replace(",", ".")
      );
      var urbanPublicTransportBoarding2Value = parseFloat(
        lines[index].split(";")[9].replace(",", ".")
      );

      for (
        var index2 = 0;
        index2 < this.regionData.ageDistribution.values.length;
        index2++
      ) {
        const element = this.regionData.ageDistribution.values[index2];
        if (
          element.transportModeId == 3 &&
          element.additionalId == ageGenderId
        ) {
          this.regionData.ageDistribution.values[index2].deboardingValue =
            longDistanceTransportDeboardingValue;
          this.regionData.ageDistribution.values[index2].boarding1Value =
            longDistanceTransportBoarding1Value;
          this.regionData.ageDistribution.values[index2].boarding2Value =
            longDistanceTransportBoarding2Value;
        }
        if (
          element.transportModeId == 2 &&
          element.additionalId == ageGenderId
        ) {
          this.regionData.ageDistribution.values[index2].deboardingValue =
            regionalPublicTransportDeboardingValue;
          this.regionData.ageDistribution.values[index2].boarding1Value =
            regionalPublicTransportBoarding1Value;
          this.regionData.ageDistribution.values[index2].boarding2Value =
            regionalPublicTransportBoarding2Value;
        }
        if (
          element.transportModeId == 1 &&
          element.additionalId == ageGenderId
        ) {
          this.regionData.ageDistribution.values[index2].deboardingValue =
            urbanPublicTransportDeboardingValue;
          this.regionData.ageDistribution.values[index2].boarding1Value =
            urbanPublicTransportBoarding1Value;
          this.regionData.ageDistribution.values[index2].boarding2Value =
            urbanPublicTransportBoarding2Value;
        }
      }
      ageGenderId++;
    }
  }
  splitTabAgeGenderAdaptationSteps(text: string) {
    var ageGenders: number = 12;
    var luggageCategory: number = 5;
    var lines = text.split(BACKSLASH_N);
    for (var index = 2; index < ageGenders + 2; index++) {
      var values = lines[index].split(";");
      for (var index2 = 1; index2 < luggageCategory + 1; index2++) {
        var ageGenderId = index - 2;
        var luggageCategoryId = index2; //LuggageCategories Beginnen mit 1 und nicht mit 0
        var value = parseFloat(values[index2].replace(",", "."));

        for (
          var index3 = 0;
          index3 < this.regionData.ageGenderAdaptationSteps.values.length;
          index3++
        ) {
          const element =
            this.regionData.ageGenderAdaptationSteps.values[index3];

          if (
            element.ageGenderId == ageGenderId &&
            element.luggageCategoryId == luggageCategoryId &&
            element.timeTypeId == 1
          ) {
            this.regionData.ageGenderAdaptationSteps.values[index3].value =
              value;
            break;
          }
        }
      }
    }
    for (
      var index = 2 + ageGenders + 2;
      index < 2 + ageGenders + 2 + ageGenders;
      index++
    ) {
      var values = lines[index].split(";");
      for (var index2 = 1; index2 < luggageCategory + 1; index2++) {
        var ageGenderId = index - 2 - ageGenders - 2;
        var luggageCategoryId = index2; //LuggageCategories Beginnen mit 1 und nicht mit 0
        var value = parseFloat(values[index2].replace(",", "."));

        for (
          var index3 = 0;
          index3 < this.regionData.ageGenderAdaptationSteps.values.length;
          index3++
        ) {
          const element =
            this.regionData.ageGenderAdaptationSteps.values[index3];

          if (
            element.ageGenderId == ageGenderId &&
            element.luggageCategoryId == luggageCategoryId &&
            element.timeTypeId == 2
          ) {
            this.regionData.ageGenderAdaptationSteps.values[index3].value =
              value;
            break;
          }
        }
      }
    }
  }
  splitTabPassengerChangeTimeVectorSteps(text: string) {
    var steps: number = 6;
    var luggageCategory: number = 5;
    var lines = text.split(BACKSLASH_N);
    var luggageCategoryId = 1; //LuggageCategories Beginnen mit 1 und nicht mit 0

    for (var index = 2; index < luggageCategory + 2; index++) {
      var values = lines[index].split(";");
      var step1Value = parseFloat(values[1].replace(",", "."));
      var step2Value = parseFloat(values[2].replace(",", "."));
      var step3Value = parseFloat(values[3].replace(",", "."));
      for (
        var index2 = 0;
        index2 < this.regionData.passengerChangeTimeVectorSteps.values.length;
        index2++
      ) {
        const element =
          this.regionData.passengerChangeTimeVectorSteps.values[index2];

        if (
          element.additionalId == luggageCategoryId &&
          element.timeTypeId == 1
        ) {
          this.regionData.passengerChangeTimeVectorSteps.values[
            index2
          ].steps1Value = step1Value;
          this.regionData.passengerChangeTimeVectorSteps.values[
            index2
          ].steps2Value = step2Value;
          this.regionData.passengerChangeTimeVectorSteps.values[
            index2
          ].steps3Value = step3Value;
          break;
        }
      }
      luggageCategoryId++;
    }
    luggageCategoryId = 1;
    for (
      var index = 2 + steps + 1;
      index < (luggageCategory + 2) * 2;
      index++
    ) {
      var values = lines[index].split(";");
      var step1Value = parseFloat(values[1].replace(",", "."));
      var step2Value = parseFloat(values[2].replace(",", "."));
      var step3Value = parseFloat(values[3].replace(",", "."));

      for (
        var index2 = 0;
        index2 < this.regionData.passengerChangeTimeVectorSteps.values.length;
        index2++
      ) {
        const element =
          this.regionData.passengerChangeTimeVectorSteps.values[index2];

        if (
          element.additionalId == luggageCategoryId &&
          element.timeTypeId == 2
        ) {
          this.regionData.passengerChangeTimeVectorSteps.values[
            index2
          ].steps1Value = step1Value;
          this.regionData.passengerChangeTimeVectorSteps.values[
            index2
          ].steps2Value = step2Value;
          this.regionData.passengerChangeTimeVectorSteps.values[
            index2
          ].steps3Value = step3Value;
          break;
        }
      }
      luggageCategoryId++;
    }
  }
  splitTabStepsWidthFactor(text: string) {
    var steps: number = 3;
    var lines = text.split(BACKSLASH_N);

    var stepsId = 1;
    for (var index = 3; index < steps + 3; index++) {
      var step1ValueBoarding = parseFloat(
        lines[index].split(";")[1].replace(",", ".")
      );
      var step2ValueBoarding = parseFloat(
        lines[index].split(";")[2].replace(",", ".")
      );
      var step3ValueBoarding = parseFloat(
        lines[index].split(";")[3].replace(",", ".")
      );

      var step1ValueDeboarding = parseFloat(
        lines[index].split(";")[4].replace(",", ".")
      );
      var step2ValueDeboarding = parseFloat(
        lines[index].split(";")[5].replace(",", ".")
      );
      var step3ValueDeboarding = parseFloat(
        lines[index].split(";")[6].replace(",", ".")
      );

      for (
        var index2 = 0;
        index2 < this.regionData.stepsWidthFactor.values.length;
        index2++
      ) {
        const element = this.regionData.stepsWidthFactor.values[index2];
        if (element.additionalId == stepsId && element.timeTypeId == 1) {
          this.regionData.stepsWidthFactor.values[index2].steps1Value =
            step1ValueBoarding;
          this.regionData.stepsWidthFactor.values[index2].steps2Value =
            step2ValueBoarding;
          this.regionData.stepsWidthFactor.values[index2].steps3Value =
            step3ValueBoarding;
        }
        if (element.additionalId == stepsId && element.timeTypeId == 2) {
          this.regionData.stepsWidthFactor.values[index2].steps1Value =
            step1ValueDeboarding;
          this.regionData.stepsWidthFactor.values[index2].steps2Value =
            step2ValueDeboarding;
          this.regionData.stepsWidthFactor.values[index2].steps3Value =
            step3ValueDeboarding;
        }
      }
      stepsId++;
    }
  }
  splitTabBoardingPlaceDensityOfPeopleFactor(text: string) {
    let lines = text.split(BACKSLASH_N);
    let scheme = new DensityOfPeoplefactor(lines);

    for (var index = 0; index < scheme.validTransportModes.length; index++) {
      // extract transport mode type
      var transportModeType = scheme.validTransportModes[index].split(
        scheme.splitChar
      )[scheme.transportModeTypeIndex];
      // extract raw value for this transport mode
      let rawValue = scheme.validTransportModes[index]
        .split(scheme.splitChar)
        [scheme.rawValueIndex].replace(
          scheme.replaceChar,
          scheme.replaceWithChar
        );

      var value = parseFloat(rawValue);

      let transportModeId: number =
        scheme.getTransportModeIdByTransportModeTypeString(transportModeType);

      this.regionData.boardingPlaceDensityOfPeopleFactor.values.find(
        (x) => x.transportModeId == transportModeId
      ).value = value;
    }
  }

  splitTabLocationWaysFactor(text: string) {
    var places: number = 3;
    var lines = text.split(BACKSLASH_N);

    var placeId: number = 1;
    for (var index = 3; index < places + 3; index++) {
      var value = parseFloat(lines[index].split(";")[1].replace(",", "."));

      for (
        var index2 = 0;
        index2 < this.regionData.locationWaysFactor.values.length;
        index2++
      ) {
        const element = this.regionData.locationWaysFactor.values[index2];
        if (element.placeId == placeId) {
          this.regionData.locationWaysFactor.values[index2].value = value;
        }
      }
      placeId++;
    }
  }
}
